import { useFetchCatalogoVisitasTraslados } from '@/shared/actions/erp/administration/catalogo-visitas-traslados.actions';

/** Slug del Parámetro que guarda el descuento (FibraPoints) por traslado. */
export const SLUG_DESCUENTO_TRASLADO_FIBRA = 'descuento_traslado_fibrapoints';

/** Fallback si el parámetro no existe todavía. */
export const DEFAULT_DESCUENTO_TRASLADO_FIBRA = 1200;

/**
 * Lee el parámetro de descuento por traslado con FibraPoints (key-value en el
 * modelo Parametro). Devuelve el valor numérico (con fallback), el registro
 * completo (para editarlo) y el estado de carga.
 */
export function useDescuentoTrasladoFibra() {
  // El descuento ya no es un Parametro suelto: es una columna de la tabla
  // CatalogoConfigVisitas y llega con el resto del catálogo en una sola
  // petición compartida por los tres hooks.
  const { data, isLoading, isRefetching } = useFetchCatalogoVisitasTraslados();

  // Compat: ya no existe el registro Parametro; el panel guarda por el
  // endpoint nuevo (guardarCatalogoVisitasTraslados).
  const parametro: any = null;

  const raw = (data as any)?.descuento_traslado_fibrapoints;
  const parsed = raw != null ? Number(raw) : NaN;
  const descuento = Number.isFinite(parsed)
    ? parsed
    : DEFAULT_DESCUENTO_TRASLADO_FIBRA;

  return { descuento, parametro, isLoading, isRefetching };
}
